import * as React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import type { QuoteBlockNested } from '../../modernBlocks.state'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'

export type QuoteBlockNestedClassNames = Partial<{
  block: string
  inner: string
  content: string
  quote: string
  quoteText: string
  figcaption: string
  author: string
  authorDescription: string
}>

export const quoteBlockNestedClasses: QuoteBlockNestedClassNames = {
  block: 'block--nested block--quote-nested block--quote',
  inner: 'block__inner',
  content: 'block__content',
  quote: 'quote__block',
  quoteText: 'quote__text quote--m',
  figcaption: 'quote__caption text--s',
  author: 'quote__author',
  authorDescription: 'quote__extra',
}

export const QuoteBlockNestedLayout = (props: QuoteBlockNested) => {
  const { author, index, text, authorDescription, design } = props
  return (
    <div key={index} className={getClassNameModern(quoteBlockNestedClasses, 'block', '')}>
      <div className={getClassNameModern(quoteBlockNestedClasses, 'inner', '')}>
        <div className={`${design === 'default' ? 'quote' : 'quote-new'} quote--text`}>
          <div className={getClassNameModern(quoteBlockNestedClasses, 'content', '')}>
            <SharedBlockLayout.SVGIcon
              iconId="#icon--quote"
              width="66px"
              height="54px"
              className="quote__icon quote__icon--top"
            />
            <div className="quote__inner">
              {text && (
                <blockquote className={getClassNameModern(quoteBlockNestedClasses, 'quote', '')}>
                  <div className={getClassNameModern(quoteBlockNestedClasses, 'quoteText', '')}>{text}</div>
                </blockquote>
              )}

              {author && (
                <div className={getClassNameModern(quoteBlockNestedClasses, 'figcaption', '')}>
                  {author && (
                    <span className={getClassNameModern(quoteBlockNestedClasses, 'author', '')}>{author}</span>
                  )}
                  {authorDescription && (
                    <>
                      {' '}
                      <span className={getClassNameModern(quoteBlockNestedClasses, 'authorDescription', '')}>
                        {authorDescription}
                      </span>
                    </>
                  )}
                </div>
              )}
            </div>
            {design == 'default' && (
              <SharedBlockLayout.SVGIcon
                iconId="#icon--quote"
                width="66px"
                height="54px"
                className="quote__icon quote__icon--bottom"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
